/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorAuctionWorksheetItemDto } from '../../models/vendor-auction-worksheet-item-dto';

export interface ApiVendorVendorAuctionSaveVendorItemPost$Params {

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
      body?: VendorAuctionWorksheetItemDto
}

export function apiVendorVendorAuctionSaveVendorItemPost(http: HttpClient, rootUrl: string, params?: ApiVendorVendorAuctionSaveVendorItemPost$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorAuctionWorksheetItemDto>> {
  const rb = new RequestBuilder(rootUrl, apiVendorVendorAuctionSaveVendorItemPost.PATH, 'post');
  if (params) {
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorAuctionWorksheetItemDto>;
    })
  );
}

apiVendorVendorAuctionSaveVendorItemPost.PATH = '/api/vendor/vendor-auction/SaveVendorItem';
